import { render, staticRenderFns } from "./AccountsHead.vue?vue&type=template&id=674ec9fa&scoped=true"
import script from "./AccountsHead.vue?vue&type=script&lang=js"
export * from "./AccountsHead.vue?vue&type=script&lang=js"
import style0 from "./AccountsHead.vue?vue&type=style&index=0&id=674ec9fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ec9fa",
  null
  
)

export default component.exports